import { render, staticRenderFns } from "./categoryItem.vue?vue&type=template&id=30cd16f4&scoped=true&lang=pug&"
import script from "./categoryItem.vue?vue&type=script&lang=js&"
export * from "./categoryItem.vue?vue&type=script&lang=js&"
import style0 from "./categoryItem.vue?vue&type=style&index=0&id=30cd16f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cd16f4",
  null
  
)

export default component.exports